import { ENTRADA } from '../entrada';
import './Login.css';
import { VideoPanel } from './VideoAcceso';

// ═══════════════════════════════════════════════════════════════════════════════
// MARCO DE ACCESO — la presentación compartida por Login, RecoveryScreen y
// ForceChangePassword. Misma identidad que el sitio público (innovalab-web).
// El texto y la animación del panel dependen de la entrada (src/entrada.js):
// el médico ve el video del portal en el teléfono; operaciones ve el equipo operando.
// Texto público en TUTEO. Solo presentación: aquí no hay lógica de auth.
// ═══════════════════════════════════════════════════════════════════════════════

export const SITIO = 'https://innovalab.scgrupomedico.com';

export const TEXTOS = {
  operaciones: {
    cejilla: 'Operaciones',
    titulo:  'Cada muestra, en su punto exacto del proceso.',
    sub:     'Ingresa con tu usuario de Innovalab.',
    correo:  'correo@scgrupomedico.com',
    Anim:    Equipo,
  },
  portal: {
    cejilla: 'Portal Médico',
    titulo:  'Los resultados de tus pacientes, validados y firmados.',
    sub:     'Ingresa con el correo que registraste en Innovalab.',
    correo:  'tu@correo.com',
    // Oct-2026: el video del portal en el teléfono reemplazó a la animación
    // de validación (Validacion queda abajo por si se quiere volver).
    Anim:    VideoPanel,
  },
};

function Molinete({ size = 34 }) {
  return (
    <svg className="lg-molinete" viewBox="0 0 100 100" width={size} height={size}
         style={{ overflow: 'visible' }} aria-hidden="true">
      <path fill="#223C6A" d="M100 0 100 50 50 0Z" />
      <path fill="#223C6A" d="M0 0 50 50 50 0Z" />
      <path fill="#223C6A" d="M100 100 100 50 50 50Z" />
      <path fill="#223C6A" d="M50 100 50 50 0 50Z" />
    </svg>
  );
}

// Copia de innovalab-web/src/components/Validacion.tsx (sin uso desde oct-2026:
// la reemplazó VideoPanel; se conserva para volver a ella si hace falta).
// eslint-disable-next-line no-unused-vars
function Validacion() {
  return (
    <svg className="val lg-anim" viewBox="0 0 760 260" role="img"
         aria-label="El valor medido se compara contra la banda de referencia y un químico biólogo lo firma.">
      <text className="val-rotulo" x="60" y="60">Banda de referencia</text>
      <rect x="60" y="76" width="560" height="34" rx="8" fill="none" stroke="rgba(255,255,255,.14)" strokeWidth="1.5" />
      <rect className="val-banda" x="214" y="76" width="252" height="34" rx="8" fill="#4A8CF0" opacity=".16" />
      <text className="val-rotulo" x="214" y="132">3.5</text>
      <text className="val-rotulo" x="446" y="132">5.1</text>
      <g className="val-valor">
        <line x1="330" y1="64" x2="330" y2="122" stroke="#4A8CF0" strokeWidth="2" strokeLinecap="round" />
        <circle cx="330" cy="93" r="5" fill="#4A8CF0" />
      </g>
      <g className="val-firma">
        <rect x="60" y="176" width="304" height="52" rx="10" fill="none" stroke="rgba(255,255,255,.18)" strokeWidth="1.5" />
        <path d="M84 202c8-10 14-10 18 0s10 10 18-4 14-6 20 4" fill="none" stroke="#4A8CF0"
              strokeWidth="2" strokeLinecap="round" className="val-trazo" />
        <text className="val-rotulo" x="150" y="199">Químico biólogo</text>
        <text className="val-rotulo" x="150" y="216">Validado y firmado</text>
      </g>
    </svg>
  );
}

// Copia de innovalab-web/src/components/Equipo.tsx — sin marca ni modelo del equipo.
function Equipo() {
  return (
    <svg className="bs lg-anim" viewBox="0 0 760 400" role="img"
         aria-label="El brazo lleva la aguja al tubo de muestra, aspira, dispensa en la cubeta y el lector mide.">
      <rect className="chasis" x="30" y="34" width="700" height="332" rx="20" />
      <circle className="led" cx="62" cy="62" r="4" />
      <line className="riel" x1="96" y1="112" x2="664" y2="112" />
      <text className="rotulo" x="96" y="330">Muestra</text>
      <g className="pieza">
        <rect x="150" y="196" width="26" height="104" rx="12" />
        <rect x="196" y="196" width="26" height="104" rx="12" />
      </g>
      <rect className="suero nivel" x="154" y="228" width="18" height="68" rx="9" />
      <rect className="suero" x="200" y="228" width="18" height="68" rx="9" />
      <text className="rotulo" x="404" y="330">Reacción</text>
      <g className="cinta">
        <g className="pieza">
          <rect x="404" y="214" width="24" height="86" rx="6" />
          <rect x="448" y="214" width="24" height="86" rx="6" />
          <rect x="492" y="214" width="24" height="86" rx="6" />
          <rect x="536" y="214" width="24" height="86" rx="6" />
          <rect x="580" y="214" width="24" height="86" rx="6" />
          <rect x="624" y="214" width="24" height="86" rx="6" />
        </g>
        <rect className="suero llenado" x="408" y="238" width="16" height="58" rx="5" />
      </g>
      <rect className="pieza" x="486" y="144" width="52" height="26" rx="6" />
      <text className="rotulo" x="486" y="136">Lector</text>
      <line className="haz" x1="512" y1="172" x2="512" y2="240" />
      <text className="lectura" x="556" y="182">4.9 mmol/L</text>
      <g transform="translate(163,112)">
        <g className="carro">
          <rect className="carro-cuerpo" x="-19" y="-13" width="38" height="26" rx="7" />
          <g className="aguja">
            <line className="aguja-linea" x1="0" y1="10" x2="0" y2="128" />
            <circle cx="0" cy="128" r="2.6" fill="#4A8CF0" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function textosEntrada() {
  return TEXTOS[ENTRADA.clave === 'operaciones' ? 'operaciones' : 'portal'];
}

export function MarcoAcceso({ children }) {
  const T = textosEntrada();
  const esOperaciones = ENTRADA.clave === 'operaciones';
  const { Anim } = T;

  return (
    <div className="lg">
      <aside className="lg-panel">
        <div>
          <div className="lg-cejilla">{T.cejilla}</div>
          <h1 className="lg-titulo">{T.titulo}</h1>
        </div>
        <Anim />
        <div className="lg-pie">
          {esOperaciones
            ? 'Acceso exclusivo del personal de Innovalab.'
            : <a href={SITIO}>← Volver a innovalab.scgrupomedico.com</a>}
        </div>
      </aside>

      <main className="lg-lado">
        <div className="lg-caja">
          <div className="lg-marca">
            <Molinete />
            <span className="lg-marca-nombre">Innovalab</span>
          </div>

          {children}

          <div className="lg-legal">
            <a href={`${SITIO}/privacidad.html`}>Privacidad</a> · <a href={`${SITIO}/terminos.html`}>Términos</a>
          </div>
        </div>
      </main>
    </div>
  );
}

// Campo de contraseña con «Mostrar / Ocultar». El estado `show` lo lleva quien lo usa.
export function CampoClave({ id, label, show, onToggle, conBoton = true, ...input }) {
  return (
    <div className="lg-campo">
      <label className="lg-label" htmlFor={id}>{label}</label>
      <div className="lg-clave">
        <input id={id} className="lg-input" type={show ? 'text' : 'password'} {...input} />
        {conBoton && (
          <button type="button" className="lg-ver" onClick={onToggle}
                  aria-label={show ? 'Ocultar contraseña' : 'Mostrar contraseña'}>
            {show ? 'Ocultar' : 'Mostrar'}
          </button>
        )}
      </div>
    </div>
  );
}
